const FETCH_MY_STORY = 'studio/storyDetail/FETCH_MY_STORY';

const FETCH_MY_STORY_EPISODES = 'studio/storyDetail/FETCH_MY_STORY_EPISODES';

const CREATE_MY_EPISODE = 'studio/storyDetail/CREATE_MY_EPISODE';

const REMOVE_MY_EPISODE = 'studio/storyDetail/REMOVE_MY_EPISODE';

const PATCH_MY_EPISODE = 'studio/storyDetail/PATCH_MY_EPISODE';

const RESET = 'studio/storyDetail/RESET';

const CANCEL_BOOKED = 'studio/storyDetail/CANCEL_BOOKED';

export default {
  FETCH_MY_STORY,
  FETCH_MY_STORY_EPISODES,
  CREATE_MY_EPISODE,
  REMOVE_MY_EPISODE,
  PATCH_MY_EPISODE,
  RESET,
  CANCEL_BOOKED,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyDetail/types.js